import { render } from "./OurWins.vue?vue&type=template&id=76eeaa56"
import script from "./OurWins.vue?vue&type=script&lang=js"
export * from "./OurWins.vue?vue&type=script&lang=js"

import "./OurWins.vue?vue&type=style&index=0&id=76eeaa56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__